import {http} from './http/request';

const loadDictOption = (dictCode) => http.get(`/sysDict/get/${dictCode}`)

export {
    loadDictOption
};
